import React, { useState, useEffect, useCallback } from 'react';
import { Box, Typography, Paper, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { getAllSclasses } from '../../redux/sclassRelated/sclassHandle';

const AdminFeeManagement = () => {
    const { sclassesList } = useSelector(state => state.sclass);
    const { currentUser } = useSelector(state => state.user);
    const dispatch = useDispatch();
    
    const [feeType, setFeeType] = useState('');
    const [amount, setAmount] = useState('');
    const [sclassName, setSclassName] = useState('');
    const [dueDate, setDueDate] = useState('');
    const [fees, setFees] = useState([]);

    useEffect(() => {
        if(currentUser?._id){
            dispatch(getAllSclasses(currentUser._id, "Sclass"));
            fetchFees();
        }
    }, [dispatch, currentUser?._id, fetchFees]);

    const fetchFees = useCallback(async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/FeeList/${currentUser._id}`);
            if (res.data.length > 0) {
                setFees(res.data);
            }
        } catch (err) {
            console.error(err);
        }
    }, [currentUser?._id]);

    const handleCreateFee = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${process.env.REACT_APP_BASE_URL}/FeeCreate`, {
                feeType,
                amount: Number(amount),
                sclassName,
                dueDate,
                school: currentUser._id
            });
            fetchFees();
            setFeeType('');
            setAmount('');
            setDueDate('');
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Box sx={{ p: 4 }}>
            <Typography variant="h4" sx={{ mb: 4, fontWeight: 'bold', color: '#0D47A1' }}>
                Institute Fee Management
            </Typography>

            <Paper sx={{ p: 3, mb: 4 }}>
                <Typography variant="h6" sx={{ mb: 2 }}>Create New Fee Structure</Typography>
                <Box component="form" onSubmit={handleCreateFee} sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                    <TextField 
                        label="Fee Type (e.g. Sem 1 Fee)" 
                        required 
                        value={feeType} 
                        onChange={(e) => setFeeType(e.target.value)} 
                    />
                    <TextField 
                        label="Amount (INR)" 
                        type="number" 
                        required 
                        value={amount} 
                        onChange={(e) => setAmount(e.target.value)} 
                    />
                    <FormControl sx={{ minWidth: 200 }}>
                        <InputLabel>Branch/Program</InputLabel>
                        <Select 
                            value={sclassName} 
                            label="Branch/Program" 
                            onChange={(e) => setSclassName(e.target.value)} 
                            required
                        >
                            {sclassesList.map(sc => (
                                <MenuItem key={sc._id} value={sc._id}>{sc.sclassName}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <TextField 
                        type="date" 
                        required 
                        value={dueDate} 
                        onChange={(e) => setDueDate(e.target.value)} 
                    />
                    <Button variant="contained" type="submit" sx={{ bgcolor: '#0D47A1' }}>
                        Create Fee
                    </Button>
                </Box>
            </Paper>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead sx={{ bgcolor: '#0D47A1' }}>
                        <TableRow>
                            <TableCell sx={{ color: 'white' }}>Fee Type</TableCell>
                            <TableCell sx={{ color: 'white' }}>Branch</TableCell>
                            <TableCell sx={{ color: 'white' }}>Amount (INR)</TableCell>
                            <TableCell sx={{ color: 'white' }}>Due Date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {fees.length > 0 ? fees.map((fee) => (
                            <TableRow key={fee._id}>
                                <TableCell>{fee.feeType}</TableCell>
                                <TableCell>{fee.sclassName?.sclassName || 'Unknown'}</TableCell>
                                <TableCell>₹{fee.amount}</TableCell>
                                <TableCell>{new Date(fee.dueDate).toLocaleDateString()}</TableCell>
                            </TableRow>
                        )) : (
                            <TableRow><TableCell colSpan={4} align="center">No fees created yet.</TableCell></TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default AdminFeeManagement;
